import { render, staticRenderFns } from "./bank-data-form.container.vue?vue&type=template&id=472972ed&scoped=true&lang=pug"
import script from "./bank-data-form.container.vue?vue&type=script&lang=ts"
export * from "./bank-data-form.container.vue?vue&type=script&lang=ts"
import style0 from "./bank-data-form.container.vue?vue&type=style&index=0&id=472972ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472972ed",
  null
  
)

export default component.exports